import { SvgIcon, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface Props {
	sx?: SxProps<Theme>;
}

export const StoreIcon: FC<Props> = (props) => (
	<SvgIcon {...props} viewBox="0 0 349 316.2">
		<path
			d="M229,134.8L229,134.8c0,6.1-5,11.1-11.1,11.1H131c-6.1,0-11.1-5-11.1-11.1v0c0-6.1,5-11.1,11.1-11.1h86.9
		C224.1,123.7,229,128.7,229,134.8z"
		/>
		<path
			d="M48.4,48.4C79.2,17.6,127.3,0,174.5,0s95.2,17.6,126.1,48.4v0c3.1,3.1,4.8,7.2,4.8,11.6v27.3h8c19.7,0,35.7,16,35.7,35.7
		v193.4H0v-194c0-19.3,15.7-35,35-35h8.6V60C43.6,55.6,45.3,51.5,48.4,48.4L48.4,48.4z M65.3,67.2v29.6c0,6.9-5.6,12.5-12.5,12.5
		H34.7c-6.9,0-12.5,5.6-12.5,12.5v171.1h105.5V226c0-8.4,6.8-15.2,15.2-15.2h63.4c8.4,0,15.2,6.8,15.2,15.2v66.9h105.5v-171
		c0-6.9-5.6-12.6-12.6-12.6h-18.9c-6.9,0-12.6-5.6-12.6-12.6V67.6c0-4.8-2.2-9.4-6-12.3c-26-19.8-65.1-32-102.4-32
		c-37.4,0-77.4,12.3-103.5,32.3C67.3,58.4,65.3,62.7,65.3,67.2z"
		/>
	</SvgIcon>
);
